import React from 'react';
import clsx from 'clsx';
import CMSImages from '@components/atoms/vc-images/components/cms-image';
import { CampaignBlock } from '@interfaces/models/campaign';
import styles from './campaign-header.module.scss';

const CampaignHeader: React.FC<CampaignBlock> = (props): React.JSX.Element => {
  const { displayTitle: title, subtitle, image } = props;
  const { filename: imgXName, url: imgPath, title: imgTitle } = image || {};

  return (
    <div className={styles.catalogHeader__campaign}>
      <h1 className={clsx(styles.catalogHeader__campaign__mainTitle, 'vc-title-m')}>{title}</h1>
      {subtitle && <article className={clsx(styles.catalogHeader__campaign__article)}>{subtitle}</article>}
      {image?.url ? (
        <CMSImages
          className={styles.campaign__img}
          wrapperProps={{
            className: styles.catalogHeader__campaign__image,
          }}
          src={imgPath}
          type="edito"
          width={500}
          height={500}
          alt={imgTitle}
          data-src={imgXName}
        />
      ) : (
        ''
      )}
    </div>
  );
};

export default CampaignHeader;
